
export default function FlightsFrom() {
  return (
<>
 <section id="schedule" className="section-with-bg">
      <div className="container" data-aos="fade-up">
              <div className="section-header">
          <h2 className="our_deals_ofr">Top Airlines Destinations</h2>
        
<p>Cheapflightsprices brings you some not-to-be missed, exclusive deals on airfares that are bound to enrich your travel experience. These deals are the latest and the best you can get. So, don't keep waiting. Book them now!</p>
        </div>
        <div className="tab-content row justify-content-center" data-aos="fade-up" data-aos-delay="200">
          <div role="tabpanel" className="col-lg-12 tab-pane fade show active" id="day-1">
        <div className="row">
          <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate7" className="nexts_deals"></span> - <span id="nextDate14" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">JFK</p><p className="dest_fl">New York</p></div>
    <div className="col-md-5 col-xs-4">
        <h4 className="rates"><i className="rates_us">$</i>2401.26*</h4>
        <p className="trips">Found 4 Hours ago</p>
              </div>
            </div>
          </div>
  <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate21" className="nexts_deals"></span> - <span id="nextDate28" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">SFO</p><p className="dest_fl">San Francisco</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2471.26*</h4>
        <p className="trips">Found 5 Hours ago</p>
              </div>
            </div>
          </div>
            <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate35" className="nexts_deals"></span> - <span id="nextDate42" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">SFO</p><p className="dest_fl">San Francisco</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>1242.20*</h4>
        <p className="trips">Found 6 Hours ago</p>
              </div>
            </div>
          </div>
            <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate49" className="nexts_deals"></span> - <span id="nextDate56" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAS</p><p className="dest_fl">Las Vegas</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2454.06*</h4>
        <p className="trips">Found 2 Hours ago</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate63" className="nexts_deals"></span> - <span id="nextDate70" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">ORD</p><p className="dest_fl">Chicago</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2282.26*</h4>
        <p className="trips">Found 4 Hours ago</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate77" className="nexts_deals"></span> - <span id="nextDate84" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">JFK</p><p className="dest_fl">New York</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2242.76*</h4>
        <p className="trips">Found 1 Hours ago</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate91" className="nexts_deals"></span> - <span id="nextDate98" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LHR</p><p className="dest_fl">London</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2142.46*</h4>
        <p className="trips">Found 4 Hours ago</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate105" className="nexts_deals"></span> - <span id="nextDate112" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">SFO</p><p className="dest_fl">San Francisco</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LHR</p><p className="dest_fl">London</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>3542.22*</h4>
        <p className="trips">Found 2 Hours ago</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate119" className="nexts_deals"></span> - <span id="nextDate126" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">IAH</p><p className="dest_fl">Houston</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LHR</p><p className="dest_fl">London</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2052.45*</h4>
        <p className="trips">Found 7 Hours ago</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate133" className="nexts_deals"></span> - <span id="nextDate140" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LAX</p><p className="dest_fl">Los Angeles</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">SYD</p><p className="dest_fl">Sydney</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2242.21*</h4>
        <p className="trips">Found 2 Hours ago</p>
              </div>
            </div>
          </div>
               <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate147" className="nexts_deals"></span> - <span id="nextDate154" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">IAD</p><p className="dest_fl">Washington</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">LHR</p><p className="dest_fl">London</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2412.16*</h4>
        <p className="trips">Found 5 Hours ago</p>
              </div>
            </div>
          </div>
               <div className="col-lg-6 col-sm-12 col-xs-12">
            <div className="row schedule-item mainsecbg">
              <p className="offer_dt"><span id="nextDate161" className="nexts_deals"></span></p>
<div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">SFO</p><p className="dest_fl">San Francisco</p></div>
<div className="col-md-1 col-sm-1 col-xs-1"><span className="bg-roundtrip"></span></div>
  <div className="col-md-3 col-sm-3 col-xs-3"><p className="dest_st">ICN</p><p className="dest_fl">Seoul</p></div>
    <div className="col-md-5 col-sm-5 col-xs-5">
        <h4 className="rates"><i className="rates_us">$</i>2424.00*</h4>
        <p className="trips">Found 5 Hours ago</p>
              </div>
            </div>
          </div>
              </div>
          </div>
          <div role="tabpanel" className="col-lg-9  tab-pane fade" id="day-2">


          </div>
          <div role="tabpanel" className="col-lg-9  tab-pane fade" id="day-3">

          

          </div>
        </div>
 <p className="price_text" style={{color: 'red'}}>*All fares are quoted in Rupees.</p>
<p className="price_text">Last updated <span className="currentsDts" id="currentsDts" style={{color: 'red'}}></span> the fares mentioned above are for Round Trip flight tickets and inclusive of fuel surcharges, service fee and taxes. Based on historical data, these fares are subject to change without prior notice and cannot be guaranteed at the time of booking. Kindly go through our <a href="https://cheapflightsprices.com/terms-and-conditions.html" target="_blank">terms and conditions</a> before booking.</p>
      
      </div>

    </section>


    </>
  );
}
